var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-card", { staticClass: "tile", attrs: { outlined: "" } }, [
    _c("div", { staticClass: "tile-label" }, [
      _vm._v("\n    " + _vm._s(_vm.label) + "\n  ")
    ]),
    _c("div", { staticClass: "tile-value" }, [
      _vm._v("\n    " + _vm._s(_vm.value) + "\n  ")
    ]),
    _c("div", { staticClass: "tile-detail" }, [
      _vm._v("\n    " + _vm._s(_vm.detail) + "\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }